import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'
import { useAuthStore } from '../stores/auth'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'portal',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    meta: { requiresAuth: true },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/dashboard/Dashboard.vue'),
      },
      {
        name: 'proxy-orders',
        path: 'proxy/orders',
        component: () => import('../pages/proxy/MyOrders.vue'),
      },
      {
        name: 'proxy-create',
        path: 'proxy/create',
        component: () => import('../pages/proxy/CreateProxy.vue'),
      },
      {
        name: 'notices',
        path: 'notices',
        component: () => import('../pages/notices/Notices.vue'),
      },
      {
        name: 'proxy-order-detail',
        path: 'proxy/orders/:id',
        component: () => import('../pages/proxy/OrderDetail.vue'),
      },
      {
        name: 'account',
        path: 'account',
        component: () => import('../pages/account/Account.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'register',
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    window.scrollTo(0, 0)
  },
  routes,
})

router.beforeEach(async (to) => {
  const authStore = useAuthStore()
  const token = localStorage.getItem('proxy-portal-token')
  if (to.meta.requiresAuth && !token) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (to.meta.requiresAuth && token && !authStore.user) {
    try {
      await authStore.fetchMe()
    } catch {
      await authStore.logout()
      return { name: 'login', query: { redirect: to.fullPath } }
    }
  }
  if ((to.name === 'login' || to.name === 'signup') && token) {
    return { name: 'dashboard' }
  }
})

export default router
